module.exports = __webpack_public_path__ + "media/images/top/green-arrow-7aa5506427d24f6b348e8d24e8127c7f.png";